// Premium dark/tech visuals for each service card
export const serviceImages = {
  websites:
    "https://images.unsplash.com/photo-1551288049-bebda4e38f71?auto=format&fit=crop&w=1200&q=80",
  ai:
    "https://images.unsplash.com/photo-1677442136019-21780ecad995?auto=format&fit=crop&w=1200&q=80",
  workflows:
    "https://static.prod-images.emergentagent.com/jobs/3d241b9d-e46f-4a5a-a0f9-bcc2d62e8f37/images/cfa8ce7eb69446af7b7b9ffd0cff669d443da874926c7d91c0b843aee9aebc39.png",
  pos:
    "https://images.unsplash.com/photo-1556742212-5b321f3c261b?auto=format&fit=crop&w=1200&q=80",
  saas:
    "https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&w=1200&q=80",
};

export const heroBg =
  "https://static.prod-images.emergentagent.com/jobs/3d241b9d-e46f-4a5a-a0f9-bcc2d62e8f37/images/4598990242669111bb495af515b9f9183e1ed4a7882e9daed9512f0fa2308b06.png";

export const aiOrb =
  "https://static.prod-images.emergentagent.com/jobs/3d241b9d-e46f-4a5a-a0f9-bcc2d62e8f37/images/0c7959991f21ebe9623399c1945edf283125e51ab623e4aedecc7a8e2e3e4174.png";
